import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { LogsService } from '../../shared/services/admin/logs.service';
import { ApiService } from '../../shared/services/api/api.service';
import * as LogsActions from './logs.actions';
import { selectLogsLastFilter } from './logs.selectors';

@Injectable()
export class LogsEffects {
  private actions$ = inject(Actions);
  private logsService = inject(LogsService);
  private apiService = inject(ApiService);
  private store = inject(Store);

  loadLogs$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(LogsActions.loadLogs),
        withLatestFrom(this.store.select(selectLogsLastFilter)),
        switchMap(([action, lastFilter]) => {
          const params: any = {
            level: action.level || lastFilter?.level,
            source: action.source || lastFilter?.source,
            module: action.module || lastFilter?.module,
            logger_name: action.logger_name || lastFilter?.logger_name,
            page: action.page || lastFilter?.page || 1,
            page_size: action.page_size || lastFilter?.page_size || 50,
            limit: action.limit || lastFilter?.limit,
            offset: action.offset || lastFilter?.offset,
          };

          // Remove undefined values
          Object.keys(params).forEach((key) => {
            if (params[key] === undefined || params[key] === null) {
              delete params[key];
            }
          });

          return this.logsService.getLogs(params, false).pipe(
            map((response) => LogsActions.loadLogsSuccess({ response })),
            catchError((error) => {
              this.apiService.showError(error.message || 'Failed to load logs', 'Error');
              return of(LogsActions.loadLogsFailure({ error }));
            }),
          );
        }),
      );
    },
    { functional: false },
  );
}
